import { useState, useEffect } from 'react'
import { validateOrReject, ValidationError } from 'class-validator'
import { useTranslation } from 'react-i18next'

const useForm = (callback: any, initialValue: any, validator: any) => {
	type Type = typeof initialValue
	const { t } = useTranslation()
	const [values, setValues] = useState<Type>(Object.assign({}, initialValue))
	const [errors, setErrors] = useState(flattenObj(values))
	const [isSubmitting, setIsSubmitting] = useState(false)

	const handleChange = (e: any) => {
		const { name, value } = e.target
		const objName = name.split('.')[0]

		setValues((prev: Type) => {
			let obj = Object.assign(values, {
				[objName]: {
					...prev[objName],
					[name.split('.')[1]]: value,
				},
			})
			return obj
		})
	}

	const updateValues = (newValues: Partial<Type>) => {
		setValues((prev: Type) => ({
			...prev,
			...newValues,
		}))
	}

	const handleSubmit = async (e: any) => {
		e.preventDefault()

		validator = validator(flattenObj(values, true))

		try {
			setIsSubmitting(true)
			await validateOrReject(validator)
			await parseErrors()
		} catch (error: any) {
			setIsSubmitting(false)
			await parseErrors(error)
		}
	}

	const parseErrors = (validationErrors?: ValidationError[]) => {
		console.log(validationErrors)
		let tempErrors = flattenObj(errors)
		if (validationErrors) {
			validationErrors.forEach((obj) => {
				if (obj.constraints) {
					let keys = Object.keys(obj.constraints)
					tempErrors[obj.property] = t(obj.constraints[keys[0]])
				}
			})
		}
		setErrors(tempErrors)
	}

	function flattenObj(
		objectToBeFlattened: Type,
		withValues: Boolean = false,
	) {
		//Magic magic..
		return Object.assign(
			{},
			...(function _flatten(obj): any {
				return [].concat(
					...Object.keys(obj).map((key) =>
						typeof obj[key] === 'object' && obj[key] !== null
							? _flatten(obj[key])
							: withValues
							  ? { [key]: obj[key] }
							  : { [key]: '' },
					),
				)
			})(objectToBeFlattened),
		)
	}

	useEffect(() => {
		if (
			Object.values(errors).find((element) => element !== '') ===
				undefined &&
			isSubmitting
		) {
			callback(values)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [errors])

	return {
		handleChange,
		handleSubmit,
		values,
		errors,
		updateValues,
	}
}

export default useForm
